var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"transition":"all 0.2s ease-out"},"stroke":"currentColor","strokeWidth":"3.6","d":"M39.5468 59.6084L7.364 38.379V24.2269M7.364 24.2269L39.4864 3L71.7295 24.2269V38.379L39.5468 17.1521L18.0923 31.3042L61.0034 59.6084L39.5468 73.7605L7.364 52.5337V66.6858L39.4864 87.9152L71.7295 66.6858V52.5337L39.5468 31.3042M7.364 24.2269L2 27.7669M71.7284 24.227L77.0914 27.7669"}));
}

Logo.defaultProps = {"viewBox":"0 0 79 91","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
